import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  Modal,
  ModalCancelButton,
  ModalHeader,
  ModalSubmitButton,
  showModal,
} from '@edna/components';

import {SleepyImage} from 'src/images';

import DeactivateClientModal from '../DeactivateClientModal';
import * as S from './style';

type TProps = {
  closeModal: TEmptyFunction;
};

const ConfirmDeactivatingModal = React.memo<TProps>(({closeModal}) => {
  const {t} = useTranslation();

  const handleSubmit = React.useCallback(() => {
    closeModal();
    showModal((closeModalProps) => <DeactivateClientModal closeModal={closeModalProps} />);
  }, [closeModal]);

  return (
    <Modal width="430px">
      <ModalHeader>{t(`ClientStatus:confirmDeactivatingModal.title`)}</ModalHeader>
      <S.ModalSubHeader>{t(`ClientStatus:confirmDeactivatingModal.subtitle`)}</S.ModalSubHeader>
      <S.ModalCenterImage as={SleepyImage} />
      <S.ModalActions>
        <ModalSubmitButton onClick={handleSubmit}>{t('Common:button.yes')}</ModalSubmitButton>
        <ModalCancelButton onClick={closeModal}>
          {t('ClientStatus:confirmDeactivatingModal.no')}
        </ModalCancelButton>
      </S.ModalActions>
    </Modal>
  );
});

ConfirmDeactivatingModal.displayName = 'ConfirmDeactivatingModal';

export default ConfirmDeactivatingModal;
